import React from "react";

class Text extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }
  componentDidMount() {
    const { text, width } = this.props;
    if (!width) return;
    this.textEllipsis(this.myRef.current, text, width);
  }
  componentDidUpdate() {
    const { text, width } = this.props;
    if (!width) return;
    this.textEllipsis(this.myRef.current, text, width);
  }
  textEllipsis(el, text, width) {
    // https://stackoverflow.com/a/37246930
    // removed first method as did not work
    if (typeof el.getComputedTextLength !== "undefined") {
      while (el.getComputedTextLength() > width) {
        text = text.slice(0, -1);
        el.textContent = text + "…";
      }
    } else {
      // the last fallback
      while (el.getBBox().width > width) {
        text = text.slice(0, -1);
        // we need to update the textContent to update the boundary width
        el.textContent = text + "…";
      }
    }
  }

  render() {
    const { text } = this.props;
    return (
      <text ref={this.myRef} {...this.props}>
        {text}
      </text>
    );
  }
}

export default Text;
